import { useQuery } from "@apollo/client";
import { MY_PROCESSING } from "MVVM/GraphQL/myProcessing";

export const ProcessingPillViewModel = ({
  skipProcessingQuery,
}: {
  skipProcessingQuery?: boolean;
}) => {
  const { data: myProcessingData } = useQuery(MY_PROCESSING, {
    skip: skipProcessingQuery,
    fetchPolicy: "network-only",
    errorPolicy: "all",
    variables: { userFeed: true, montages: true },
  });

  return {
    total: myProcessingData?.myProcessing?.userFeed,
  };
};
